import { FullscreenSpinner } from "@medbillai/ui";
import { Flag } from "@medbillai/utils";
import { useBoolVariation } from "../../lib/flag";
import { useFlagContextIsReady, useFlagHasIdentified } from "../../lib/flag/shared";
import { BillsScreen } from "./bills";
import { BillsClaimsScreen } from "./records/BillsClaimsScreen";

// Until identified the flag reads its default, so the redesign waits for it.
export const useBillsClaimsRedesign = () => {
  const identified = useFlagHasIdentified();
  const redesign = useBoolVariation(Flag.BILLS_CLAIMS_REDESIGN, false);
  return identified && redesign;
};
type BillsTabProps = {
  /** Web's split view on the list's own route: open the first record beside it. */
  selectFirst?: boolean;
};
const BillsList = ({
  selectFirst
}: BillsTabProps) => useBillsClaimsRedesign() ? <BillsClaimsScreen selectFirst={selectFirst} /> : <BillsScreen />;
export const BillsTab = ({
  selectFirst = false
}: BillsTabProps) => useFlagContextIsReady() ? <BillsList selectFirst={selectFirst} /> : <FullscreenSpinner />;